import { gsap } from "./gsap.js";
import {
  trapFocus,
  removeTrapFocus,
  defineElement,
} from "./gw.js";
class DetailsModal extends HTMLElement {
  constructor() {
    var _a;
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");
    this.detailsContainer.addEventListener(
      "keyup",
      (event) => event.code.toUpperCase() === "ESCAPE" && this.close(),
    );
    this.summaryToggle.addEventListener(
      "click",
      this.onSummaryClick.bind(this),
    );
    (_a = this.querySelector('button[type="button"]')) == null
      ? void 0
      : _a.addEventListener("click", this.close.bind(this));
    this.summaryToggle.setAttribute("role", "button");
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open")
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    )
      this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");
    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])'),
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("overflow-hidden");
  }
}
defineElement("details-modal", DetailsModal);
class SearchModal extends DetailsModal {
  constructor() {
    super();
    this.searchModal = this.detailsContainer.querySelector(".search-modal");
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");
    const gmm = gsap.matchMedia();
    gmm.add("(min-width: 991px)", () => {
      gsap.set(this.searchModal, {
        width: this.detailsContainer.hasAttribute("open") ? "200px" : "0px",
      });
      gsap.fromTo(
        this.searchModal,
        {
          opacity: 0,
          width: "0px",
        },
        {
          opacity: 1,
          width: "200px",
          duration: 0.35,
          ease: "power2",
        },
      );
    });
    gmm.add("(max-width: 990px)", () => {
      gsap.set(this.searchModal, {
        width: "100%",
      });
      gsap.fromTo(
        this.searchModal,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.35,
          ease: "power2",
        },
      );
    });
    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])'),
    );
  }

  close(focusToggle = true) {
    const gmm = gsap.matchMedia();
    gmm.add("(min-width: 991px)", () => {
      gsap
        .to(this.searchModal, {
          opacity: 0,
          width: "0px",
          duration: 0.35,
          ease: "power2",
        })
        .then(() => {
          this.detailsContainer.removeAttribute("open");
          document.body.removeEventListener("click", this.onBodyClickEvent);
          document.body.classList.remove("overflow-hidden");
          removeTrapFocus(focusToggle ? this.summaryToggle : null);
        });
    });
    gmm.add("(max-width: 990px)", () => {
      gsap
        .to(this.searchModal, {
          opacity: 0,
          duration: 0.35,
          ease: "power2",
        })
        .then(() => {
          this.detailsContainer.removeAttribute("open");
          document.body.removeEventListener("click", this.onBodyClickEvent);
          document.body.classList.remove("overflow-hidden");
          removeTrapFocus(focusToggle ? this.summaryToggle : null);
        });
    });
  }
}
defineElement("search-modal", SearchModal);
export { DetailsModal };
